import React, { Fragment } from 'react';
import { GOOGLE_MAPS_LINK } from '@/constants';
import { styWrapper } from './styles';
import ButtonLiveBCA from './ButtonLiveBCA';
import ButtonLiveBRI from './ButtonLiveBRI';
import InfoBox from './InfoBox';

function AmplopSection() {
  return (
    <Fragment>
      <div id="fh5co-couple-story" className="fh5co-section-gray" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Amplop Digital</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_LINK}
                  title="Click untuk melihat peta di Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                  {/*<strong>Rumah Mempelai Wanita, Semarang</strong>*/}
                </a>{' '}
                <br />
                Doa Restu Anda merupakan karunia yang sangat berarti bagi kami.<br/>
                Dan jika memberi adalah ungkapan tanda kasih Anda, Anda dapat memberi kado secara cashless.
              </p>             
             </div>
             <div className="col-md-5 col-md-offset-1">
                <p align="center">
                  <h3> PT Bank Central Asia </h3>
                  Nomor Rekening : 7830038617 <br/>
                  Atasnama : Mei Nilasari <br/>   
                </p>
                <ButtonLiveBCA />             
              </div>
             {/*<div className="col-md-5 col-md-offset-1" >
                
             </div>*/}
             <br/>
              <div className="col-md-3 col-md-offset-1">
                <p align="center">
                  <h4> PT Bank Rakyat Indonesia </h4>
                  Nomor Rekening : 105801008180537 <br/>
                  Atasnama : Mei Nilasari <br/>
                </p>
                <ButtonLiveBRI />
              </div>
              {/*<div className="col-md-3 col-md-offset-1" >
                <ButtonLiveBRI />
              </div>*/}
          </div>
          <p>
          </p>
          <p>
          </p>
          <br/>
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Kirim Hadiah</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_LINK}
                  title="Click untuk melihat peta di Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                  <strong>Rumah Mempelai Wanita, Semarang</strong>
                </a>{' '}
                <br />
                Jl. Ganginsari IX No.34 RT01 RW05, Bangetayu Wetan, Kec. Genuk, <br />
                Kota Semarang, Jawa Tengah 50115
              </p>             
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(AmplopSection);
